import { Declaration } from 'store/declarations/declaration';
import { StyledButton } from 'views/declarations/declaration-tabs/declaration-form/Form.styles';
import { MIRRORED_DECLARATION_TARGET } from './constants';
import MirroredDeclarationAlreadyExistsModal from './MirroredDeclarationAlreadyExistsModal';
import useMirroringPreparation from './useMirroringPreparation';
import ValidateBeforeGeneratingModal from './ValidateBeforeGeneratingModal';

type Props = {
    declaration: Declaration | undefined;
    manifestId?: string;
    jobId?: string;
};

const GenerateMirroredDeclarationButton = ({ declaration, manifestId, jobId }: Props) => {
    const {
        isPreparing,
        start,
        existingMirroredDeclarations,
        replaceExistingMirroredDeclaration,
        viewExistingMirroredDeclaration,
        dismissExistingMirroredDeclaration,
        isValidationPromptOpen,
        validateThenContinue,
        skipValidationAndContinue,
        dismissValidationPrompt,
    } = useMirroringPreparation({ declaration, manifestId, jobId });

    return (
        <>
            <StyledButton loading={isPreparing} onClick={start}>
                Generate {MIRRORED_DECLARATION_TARGET.messageType}
            </StyledButton>

            {existingMirroredDeclarations.length > 0 && (
                <MirroredDeclarationAlreadyExistsModal
                    open
                    declarations={existingMirroredDeclarations}
                    manifestId={manifestId}
                    jobId={jobId}
                    onGenerateNew={replaceExistingMirroredDeclaration}
                    onViewExisting={viewExistingMirroredDeclaration}
                    onClose={dismissExistingMirroredDeclaration}
                />
            )}

            <ValidateBeforeGeneratingModal
                open={isValidationPromptOpen}
                messageType={MIRRORED_DECLARATION_TARGET.messageType}
                onValidate={validateThenContinue}
                onSkipValidation={skipValidationAndContinue}
                onClose={dismissValidationPrompt}
            />
        </>
    );
};

export default GenerateMirroredDeclarationButton;
